<template>
        <div v-if="show.vessels" :class="['borderR5', 'mt-3', 'nb']" >
            <ul ref="vlist" :class="['vessel-list']" id="vsl-list">
                <li v-for="(vessel, index) in vesselsList">
                    <a :class="{'selectedFleet': index == selected.vesselIndex}" @click.prevent="selectVessel(index)" href="#">{{vessel.name}}</a>
                </li>
            </ul>
        </div>
</template>

<style>
    a.selectedFleet {
        font-weight: 700;
    }
    .nb {
        padding-top: 0 !important;
    }
    .nb .vessel-list {
        padding-top: 20px;
    }
    ul.vessel-list {
        display: flex;
        flex-flow: row wrap;
        padding-bottom: 30px;
        max-height: 780px;
        overflow-y: scroll;
    }

    /* width */
    ul.vessel-list::-webkit-scrollbar {
        width: 10px;
    }

    /* Track */
    ul.vessel-list::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px #f0f0f0;
        border-radius: 10px;
    }

    /* Handle */
    ul.vessel-list::-webkit-scrollbar-thumb {
        background: #337cb9;
        border-radius: 5px;
    }

    ul.vessel-list li {
        padding: 15px;
        min-width: 170px;
        flex-basis: 25%;
    }

    @media (max-width:768px){
        ul.vessel-list li {
            flex: 1;
            flex-basis: 50% !important;
            padding: 15px;
            min-width: 50% !important;
        }
        ul.vessel-list{
            flex-flow: row wrap !important;
        }
    }

    ul.vessel-list.fleet-list.fleet-item li {width: 180px;height: 30px;padding: 20px;}
</style>
<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    data(){
        return {
            newVessel:"",
        }
    },

    computed: {
           ...mapGetters([
                'lng',
                 'show',
                 'selected',
                 'fleets',
                 'isBlocked'
                ]),
        vesselsList(){
            let vessels = this.selected.fleet.vessels;
            vessels.sort((a, b) => {
                const n1 = a.name.toLowerCase();
                const n2 = b.name.toLowerCase();
                if (n1 > n2) {
                    return 1;
                } else if (n2 > n1) {
                    return -1;
                } else {
                    return 0;
                }
            });
            return vessels;
        }

   },
   methods: {
        ...mapActions([
            'selectVessel',
            ]),
   }


}


</script>




// WEBPACK FOOTER //
// Vessels.vue?40f21caa